import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../list.css";

import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import {
  Grid,
  Segment,
  Pagination,
  Button,
  Menu,
  Modal,
  Header,
  Divider,
} from "semantic-ui-react";
import Table from "react-bootstrap/Table";

import ReactTooltip from "react-tooltip";
import { Message, Icon } from "semantic-ui-react";
import { API_BASE_URL } from "../utils/endpoints";
var viewDatadownload = "";

var data_csv = [];

const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

class ContactUSView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      totalpage: "1",
      activePage: 1,
      idRecord: "",
      isArabic: false,
      viewDatadownload: "",
      fromDate: "",
      toDate: "",
      modalOpenFilterDetails: false,
      filterTotalpage: 1,
      displayViewBox:false,
    };
  }

  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });

  onChangeFromDate = (event) => {
    const date = new Date(event.target.value);
    const datevalue = date.toLocaleDateString();
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    const fromDate = day + "-" + month + "-" + year + " " + time;
    this.setState({ fromDate: fromDate });
  };

  onChangeToDate = (event) => {
    const date = new Date(event.target.value);
    const datevalue = date.toLocaleDateString();
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    const toDate = day + "-" + month + "-" + year + " " + time;
    this.setState({ toDate: toDate });
  };

  filterData() {
    this.setState({ modalOpenFilterDetails: false });
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = 0;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/corpsms/getcontactus?fromDate=${encodeURI(
        this.state.fromDate
      )}&page=${page_num}&toDate=${encodeURI(this.state.toDate)}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/core/corpsms/getcontactus?fromDate=${encodeURI(
          this.state.fromDate
        )}&page=${page_num}&toDate=${encodeURI(this.state.toDate)}`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }
      const data = res.data.result.allData;
      document.querySelector(".pagination").style = "display:none";
      document.querySelector(".filterpagination").style = "display:block";
      if (data != undefined) {
        this.setState({ data });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
      }
    });
  }

  handlePaginationFilterChange = (e, { activePage }) => {
    var token = reactLocalStorage.get("accessToken");
    window.scrollTo(500, 0);
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page = activePage - 1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getcontactus?page=" + page;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getcontactus?page=" + page;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }
      const data = res.data.result.allData;
      if (data != undefined) {
        var request = res.data.result.allData;
        var i;
        for (i = 0; i < request.length; i++) {
          data_csv.push({
            name: request[i].name,
            mobile_number: request[i].mobile_number,
            email: request[i].email,
            question: request[i].question,
          });
        }

        this.setState({ data });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
      }
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
    var token = reactLocalStorage.get("accessToken");
    window.scrollTo(500, 0);
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page = activePage - 1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getcontactus?page=" + page;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getcontactus?page=" + page;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }
      const data = res.data.result.allData;
      if (data != undefined) {
        var request = res.data.result.allData;
        var i;
        for (i = 0; i < request.length; i++) {
          data_csv.push({
            name: request[i].name,
            mobile_number: request[i].mobile_number,
            email: request[i].email,
            question: request[i].question,
          });
        }

        this.setState({ data });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
      }
    });
  };
  componentWillMount() {
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page = this.state.activePage - 1;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getcontactus?page=" + page;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getcontactus?page=" + page;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }
      const data = res.data.result.allData;
      document.querySelector(".pagination").style = "display:block";
      document.querySelector(".filterpagination").style = "display:none";
      
      if (res.data.result.count == 0) {
        // document.querySelector('.export').style='display:none'
      }
      if (data != undefined) {
        var request = res.data.result.allData;
        var i;
        for (i = 0; i < request.length; i++) {
          data_csv.push({
            name: request[i].name,
            mobile_number: request[i].mobile_number,
            email: request[i].email,
            question: request[i].question,
          });
        }

        this.setState({ data });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
      }
    });
  }
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      //      document.querySelector(".redd_color").style =
      //       "text-align:right;width: 20%;margin-right: 14%;white-space: pre;";
      //document.querySelector(".Logo_auth_contact").style = "float: left;";
      document.querySelector(".table").style = "width: 95%;margin-right: 2.5%;";
      document.querySelector(".ui.pagination.menu").style =
        "float: left !important; margin-left: 7% !important;";
      document.querySelector(".fixed_bulk").style =
        "margin-right: 0% !important;";
      document.querySelector(".contact_label").style =
        "text-align:right !important;";
    }
  }
  test(value) {
    var d = new Date(value),
      dformat =
        [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    return dformat;
  }
  export_Data = (e) => {
    setInterval(this.exportData(), 3000);
  };
  exportData(event) {
   // document.querySelector(".viewBox").style = "display:block";

    var x = this;
    x.setState({
      displayViewBox:true
    })

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_contactus";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };

    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
           // document.querySelector(".viewBox").style = "display:block";
           x.setState({
            displayViewBox:true
          })
            viewDatadownload = response.data.status;
            this.setState({ viewDatadownload: response.data.status });
            x.exportDataInterval();
          } else if (response.data.status === "ready to download") {
            collectionName = response.data.file_name;
            //document.querySelector(".viewBox").style = "display:none";
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
            x.setState({
              displayViewBox:false
            })
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  exportDataInterval() {
    document.querySelector(".viewBox").style = "display:block";
    var exportcall = setInterval(function() {
      var x = this;

      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var collectionName = "corpsms_contactus";
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" +
          collectionName;
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" + collectionName;
      }
      var headers = {
        "Content-Type": "application/json",
        token: token,
      };

      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              //document.querySelector(".viewBox").style = "display:block";
              x.setState({
                displayViewBox:true
              })
              this.setState({ viewDatadownload: response.data.status });
              viewDatadownload = response.data.status;
            } else if (response.data.status === "ready to download") {
              clearInterval(exportcall);
              collectionName = response.data.file_name;
              document.querySelector(".viewBox").style = "display:none";
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
              x.setState({
                displayViewBox:false
              })
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 3000);
  }
  render() {
    const { activePage } = this.state;
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided className="fixed_bulk">
                <Grid.Row
                  stretched
                  className="fixed_header"
                  style={{ marginRight: this.state.isArabic ? "0px" : "" }}
                >
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style contact_label">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />
                <Divider horizontal>
                  {" "}
                  <Header as="h3" color="black">
                    <Icon name="phone square" color="black" />{" "}
                    {this.state.isArabic
                      ? "دليل التواصل "
                      : "Contact us Information"}{" "}
                  </Header>{" "}
                </Divider>
                { this.state.displayViewBox && <div className="viewBox ">
                
                <Message icon className="download_box">
                  <Icon name="circle notched" loading />
                  <Message.Content>
                    <Message.Header>Wait for downloading</Message.Header>
                    {this.state.viewData}
                  </Message.Content>
                </Message>
              </div>}
              <br></br>
                <div className="buttonsHeader">
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon name="sort amount up" /> {i18n.t("filter.label")}
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentWillMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.exportData}
                  >
                    <Icon
                      name="file excel"
                      onClick={this.exportData}
                      color="black"
                    />{" "}
                    {i18n.t("export.label")}
                  </Button>
                </div>
                <br /> <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead
                    className="head"
                    style={{ color: "black", fontWeight: "bold" }}
                  >
                    <tr>
                      <td> {i18n.t("name.label")}</td>
                      <td> {i18n.t("email.label")}</td>
                      <td> {i18n.t("Mobile_Number.label")}</td>
                      <td> {i18n.t("question.label")} </td>
                      <td width={3}>{i18n.t("time.label")} </td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data
                      .slice(0)
                      .reverse()
                      .map((person) => (
                        <tr>
                          <td collapsing> {person.name} </td>
                          <td>{person.created_by}</td>
                          <td collapsing>{person.mobile_number}</td>
                          <td collapsing> {person.question} </td>
                          <td collapsing>
                            {" "}
                            {person.created_time
                              ? this.test(person.created_time)
                              : ""}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                  <br />
                  <tfoot style={{ textAlign: "right" }}>
                    <div className="pagination" style={{ display: "block" }}>
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.totalpage}
                        style={{ floated: "left" }}
                      />
                    </div>
                    <div
                      className="filterpagination"
                      style={{ display: "none" }}
                    >
                      {" "}
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationFilterChange}
                        totalPages={this.state.filterTotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </div>
                  </tfoot>
                </Table>
              </Segment>
            </div>
          </div>

          {/* ////////////////////////////////// filter////////////////////////////////*/}
          <Modal
            closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="large"
            className="add"
            open={this.state.modalOpenFilterDetails}
            onClose={this.handleCloseFilterDetails}
            size="small"
            style={this.state.isArabic ? filtera : filter}
          >
            <Header content="Filter" />
            <Modal.Content scrolling>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                {i18n.t("start_date.label")}
              </label>
              <br />
              <input
                type="datetime-local"
                onChange={this.onChangeFromDate}
                className="dateinput"
              />

              <br />

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                <br />
                {i18n.t("end_date.label")}
              </label>
              <input
                type="datetime-local"
                onChange={this.onChangeToDate}
                className="dateinput"
              />

              <br />
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={() => {
                  this.filterData();
                }}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseFilterDetails}
              />
            </Modal.Actions>
          </Modal>
          
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(ContactUSView);
